import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import LoginPage from "@/pages/LoginPage";
import RegisterPage from "@/pages/RegisterPage";
import GamePage from "@/pages/GamePage";
import ScoreboardPage from "@/pages/ScoreboardPage";
import RiderProfilePage from "@/pages/RiderProfilePage";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import "@/App.css";

function Protected({ children }) {
  const { user } = useAuth();
  const location = useLocation();
  if (user === undefined) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-hammerl-paper text-hammerl-pencil font-mono text-sm">
        Synergisiere Sitzung…
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  return children;
}

function HomeRedirect() {
  const { user } = useAuth();
  if (user === undefined) return null;
  return <Navigate to={user ? "/play" : "/login"} replace />;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomeRedirect />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/play" element={<Protected><GamePage /></Protected>} />
            <Route path="/scoreboard" element={<ScoreboardPage />} />
            <Route path="/rider/:id" element={<RiderProfilePage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
